var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40625 15.7005V2.48016C4.40625 2.09057 4.56101 1.71695 4.83649 1.44147C5.11197 1.16599 5.48559 1.01123 5.87518 1.01123H11.7509C12.1405 1.01123 12.5141 1.16599 12.7896 1.44147C13.065 1.71695 13.2198 2.09057 13.2198 2.48016V15.7005H4.40625Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4066 8.35596H2.93768C2.54809 8.35596 2.17447 8.51072 1.89899 8.7862C1.62351 9.06167 1.46875 9.4353 1.46875 9.82488V14.2317C1.46875 14.6212 1.62351 14.9949 1.89899 15.2704C2.17447 15.5458 2.54809 15.7006 2.93768 15.7006H4.4066",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2207 6.15234H14.6896C15.0792 6.15234 15.4528 6.30711 15.7283 6.58258C16.0038 6.85806 16.1586 7.23169 16.1586 7.62127V14.2314C16.1586 14.621 16.0038 14.9947 15.7283 15.2701C15.4528 15.5456 15.0792 15.7004 14.6896 15.7004H13.2207",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34473 3.94922H10.2826",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34473 6.88721H10.2826",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34473 9.82471H10.2826",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34473 12.7627H10.2826",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6271,
    height: 17.6271,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon 3.df6ae03e02cfd6042d5922f607775a30.svg";
export { ForwardRef as ReactComponent };